/** SessionStorage flag helpers for the welcome plan-tour handoff. */
import { ONBOARDING_WELCOME_PLAN_TOUR_SESSION_KEY } from '@/features/onboarding/constants/welcomePlanTour';

const ACTIVE = 'active';

export function beginOnboardingWelcomePlanTour() {
  try {
    sessionStorage.setItem(ONBOARDING_WELCOME_PLAN_TOUR_SESSION_KEY, ACTIVE);
  } catch {
    /* private mode */
  }
}

export function isOnboardingWelcomePlanTourPending() {
  try {
    return (
      sessionStorage.getItem(ONBOARDING_WELCOME_PLAN_TOUR_SESSION_KEY) ===
      ACTIVE
    );
  } catch {
    return false;
  }
}

export function endOnboardingWelcomePlanTour() {
  try {
    sessionStorage.removeItem(ONBOARDING_WELCOME_PLAN_TOUR_SESSION_KEY);
  } catch {
    /* private mode */
  }
}
